import { PriceAsIndexPercentageFixedOnEnum } from 'api';
import { useWatch } from 'react-hook-form';

import { SelectField } from '../SelectField/SelectField';
import { TextField } from '../TextField/TextField';

export const PriceAsIndexFixPriceAtField = ({
  label,
  name,
  size,
  fullWidth = true,
}: {
  label: string;
  name: string;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
}) => {
  const chosenOption = useWatch({ name: `${name}_options` });
  const options = [
    { label: '3 months avg', value: PriceAsIndexPercentageFixedOnEnum['3_MONTHS_AVG'] },
    { label: 'Cash (spot)', value: PriceAsIndexPercentageFixedOnEnum.CASH_SPOT },
    { label: 'Lower of two at fixing', value: PriceAsIndexPercentageFixedOnEnum.LOWER_OF_TWO_AT_FIXING },
    { label: 'Other', value: PriceAsIndexPercentageFixedOnEnum.OTHER },
  ];

  return (
    <>
      <SelectField label={label} options={options} name={`${name}_options`} size={size} fullWidth={fullWidth} />
      {chosenOption === 'OTHER' && (
        <TextField
          size="medium"
          name={`${name}_other_details`}
          label={label}
          type="text"
          slotProps={{
            htmlInput: {
              maxLength: 200,
            },
          }}
        />
      )}
    </>
  );
};
